import { baseballLogicValidator } from './BaseballLogicValidator';
import { baserunnersValidator } from './BaserunnersValidator';
import { basicPlayerValidator } from './BasicPlayerValidator';
import { emptyCellValidator } from './EmptyCellValidator';
import { noteResolvedValidator } from './NoteResolvedValidator';
import { playerValidator } from './PlayerValidator';
import { playResultValidator } from './PlayResultValidator';
import { previousRowConsistencyValidator } from './PreviousRowConsistencyValidator';

/**
 * All validators, including Player Tracking features
 */
export const allValidators = [
  emptyCellValidator,
  noteResolvedValidator,
  previousRowConsistencyValidator,
  baseballLogicValidator,
  playerValidator,
  playResultValidator,
  baserunnersValidator,
];

/**
 * Only basic validators, without Player Tracking features
 */
export const basicValidators = [
  emptyCellValidator,
  noteResolvedValidator,
  previousRowConsistencyValidator,
  baseballLogicValidator,
  basicPlayerValidator,
];
